export const getMaskedCardNumber = (card) => {
    const lastFourDigits = card.CardNumber?.substring(card.CardNumber?.length - 4) ?? "";
    const maskedCard = "•••• •••• •••• " + lastFourDigits;
    return maskedCard;
};
